import React, { Component } from 'react'
import _ from 'lodash'
import { Alert, Button, Col, DatePicker, Form, Input, message, Select } from 'antd'
import { strVal } from '../../../../../modules/Utils'
import * as moment from 'moment'
import CountrySelect from '../../../../../elements/Select/Country'
import { compose } from 'recompose'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'

const FormItem = Form.Item
const { TextArea } = Input
const Option = Select.Option

class Personal extends Component {
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        values['dob'] = values['dob'] instanceof moment ? values['dob'].format('YYYY-MM-DD') : ''

        let member = Object.assign(
          {},
          {
            _id: strVal(this.props, 'member._id'),
            _rev: strVal(this.props, 'member._rev'),
            _key: strVal(this.props, 'member._key'),
          },
          values,
        )
        // message.success('Updated !')
        let results = await this.props.handleSubmit(member)
        results && message.success('Updated !')
        // this.props.member = results
      } else {
        message.error('Invalid')
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { formItemLayout, member, submitting, error, fetching, type } = this.props
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 14,
          offset: 4,
        },
      },
    }
    return (
      <Form layout="vertical" onSubmit={this.handleSubmit}>
        <FormItem label="Name" {...formItemLayout}>
          <Col span={3}>
            <FormItem {...formItemLayout}>
              {getFieldDecorator('n.prefix', {
                initialValue: strVal(member, 'n.prefix'),
              })(
                <Select allowClear={true} placeholder="Prefix">
                  <Option value="mr">Mr</Option>
                  <Option value="mrs">Mrs</Option>
                  <Option value="ms">Ms</Option>
                  <Option value="miss">Miss</Option>
                  <Option value="dr">Dr</Option>
                  <Option value="prof">Prof</Option>
                  <Option value="sir">Sir</Option>
                  <Option value="datuk">Datuk</Option>
                  <Option value="datin">Datin</Option>
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={7}>
            <FormItem {...formItemLayout}>
              {getFieldDecorator('n.family', {
                initialValue: strVal(member, 'n.family'),
              })(<Input placeholder="Family Name/ Father Name" />)}
            </FormItem>
          </Col>
          <Col span={7}>
            <FormItem {...formItemLayout}>
              {getFieldDecorator('n.given', {
                initialValue: strVal(member, 'n.given'),
              })(<Input placeholder="Given Name" />)}
            </FormItem>
          </Col>
          <Col span={7}>
            <FormItem {...formItemLayout}>
              {getFieldDecorator('n.middle', {
                initialValue: strVal(member, 'n.middle'),
              })(<Input placeholder="Middle Names" />)}
            </FormItem>
          </Col>
        </FormItem>

        <FormItem label="Full Name" {...formItemLayout}>
          {getFieldDecorator('fn', {
            initialValue: strVal(member, 'fn'),
            rules: [
              {
                required: true,
                message: "Full Name can't be empty ",
              },
            ],
          })(<Input placeholder="Full Name" />)}
        </FormItem>
        <FormItem label="Preferred Name" {...formItemLayout}>
          {getFieldDecorator('nickname', {
            initialValue: strVal(member, 'nickname'),
          })(<Input placeholder="Preferred name" />)}
        </FormItem>
        <FormItem label="Position" {...formItemLayout}>
          {getFieldDecorator('position', {
            initialValue: strVal(member, 'position'),
          })(<Input placeholder="Position" />)}
        </FormItem>

        <FormItem label="Nationality" {...formItemLayout}>
          <Col span={8}>
            <FormItem {...formItemLayout}>
              {getFieldDecorator('cob', {
                initialValue: member.cob,
              })(<CountrySelect placeholder="Country of Nationality" />)}
            </FormItem>
          </Col>
          <Col span={5}>
            <FormItem {...formItemLayout}>
              {getFieldDecorator('dob', {
                initialValue: member.dob ? moment(member.dob) : member.dob,
              })(<DatePicker placeholder="Date of Birth" />)}
            </FormItem>
          </Col>
          <Col span={5}>
            <FormItem {...formItemLayout}>
              {getFieldDecorator('gender', {
                initialValue: _.get(member, 'gender'),
              })(
                <Select placeholder="Gender">
                  <Option value="M">Male</Option>
                  <Option value="F">Female</Option>
                  <Option value="X">Unspecified</Option>
                </Select>,
              )}
            </FormItem>
          </Col>
        </FormItem>
        <FormItem label="Marital Status" {...formItemLayout}>
          <Col span={5}>
            <FormItem {...formItemLayout}>
              {getFieldDecorator('marital', {
                initialValue: _.get(member, 'marital'),
              })(
                <Select placeholder="Marital Status">
                  <Option value="single">Single</Option>
                  <Option value="married">Married</Option>
                  <Option value="defacto">De Facto</Option>
                  <Option value="separated">Separated</Option>
                  <Option value="divorced">Divorced</Option>
                  <Option value="widowed">Widowed</Option>
                </Select>,
              )}
            </FormItem>
          </Col>
        </FormItem>
        <FormItem label="Profile" {...formItemLayout}>
          {getFieldDecorator('profile', {
            initialValue: strVal(member, 'profile'),
          })(<TextArea placeholder="Profile" rows={4} />)}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button loading={submitting} type="primary" htmlType="submit">
            Update
          </Button>
          {error.key !== '' ? (
            <Alert
              key={error.key}
              message={error.message === '' ? 'failed!' : error.message}
              type="error"
              closable
            />
          ) : null}
        </FormItem>
      </Form>
    )
  }
}

export default compose(withLoadingSection, Form.create())(Personal)
